var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({staticClass:"secondary",attrs:{"outlined":"","depressed":"","dark":"","height":_vm.height},on:{"click":function($event){return _vm.$emit('click')}}},'v-btn',_vm.$attrs,false),[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-plus")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }